import { Box, Text } from "@chakra-ui/react";
import React from "react";

export default function NoPage() {
  return (
    <Box h="100%" display="flex" alignItems="center" justifyContent="center">
      <Text fontWeight="600" fontSize="2xl">
        404
      </Text>
    </Box>
  );
}
